// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_x-2";
export var blackBorderOnHover = "_x-7";
export var cell = "_x-6";
export var cellContainer = "_x-3";
export var checked = "_x-8";
export var disabled = "_x-5";
export var featuredIconCellContainer = "_x-9";
export var featuredIconTextContainer = "_x-b";
export var featuredIconWrapper = "_x-a";
export var noBorder = "_x-c";
export var orangeSelectedRow = "_3b-3";
export var overflowableText = "_x-0";
export var overflowableTextContainer = "_x-1";
export var row = "_z-0";
export var rowCheckboxCell = "_x-4";
export var selectableTable = "_3b-2";